export default __webpack_public_path__ + "static/scam-alert-image-4-731608532f2498773691c1858feab407.webp";